// import "./AudioComp.css"
import React, { useEffect } from "react"
import Style from './audio.module.scss'

function Audio({ audio }) {
  useEffect(()=>{
    function enableAutoplay() { 
      document.querySelector("audio").play();
    }
    enableAutoplay()
  },[])
  return (
    

      <div className={Style.video_camp} >
        <div className={Style.video_container}>
          

          <audio id='audio' src={audio} autoplay controls></audio>

          
          </div>
      </div>

    



  )
}
export default Audio